var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-table" },
    [
      _c(
        "el-table",
        {
          staticStyle: { margin: "0", "border-collapse": "collapse" },
          attrs: {
            "header-cell-class-name": "order-table-header",
            "show-header": true,
            data: _vm.orders,
          },
        },
        [
          _c("el-table-column", {
            attrs: { sortable: "", prop: "order_id", label: "Order#" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c(
                      "router-link",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          "font-family": "Equip",
                          "text-decoration": "underline",
                          color: "#1998d5",
                        },
                        attrs: {
                          to: {
                            name: "OrderWidget",
                            query: { orderId: props.row.order_id },
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          #" +
                            _vm._s(props.row.order_id) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "Order Date" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("time-zone-formatter", {
                      attrs: {
                        "current-time": props.row.created_at,
                        "output-format": "MMM D, YYYY",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "state", label: "Status" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("OrderStatus", {
                      attrs: { "order-status": scope.row.state },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "updated_at", label: "Shipped Date" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("time-zone-formatter", {
                      attrs: {
                        "current-time": props.row.updated_at,
                        "output-format": "MMM D, YYYY",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "item_quantity", label: "Items" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }